import { apiService } from './apiService';
import { logger } from './logger';
import { SCANNER_SETTINGS_PREF_KEY, ColorEffect } from '../types';

export interface ScannerSettings {
    resolution: { width: number; height: number } | null; // null znamená výchozí systémové
    jpegQuality: number;
    defaultPaperSnapEffect: ColorEffect;
}

const SCANNER_SETTINGS_KEY = SCANNER_SETTINGS_PREF_KEY;

// Výchozí nastavení, pokud uživatel ještě žádné neuložil.
const DEFAULT_SCANNER_SETTINGS: ScannerSettings = {
    resolution: { width: 1920, height: 1080 }, // Výchozí je Full HD
    jpegQuality: 1.0, // Výchozí je maximální kvalita
    defaultPaperSnapEffect: 'bw_adaptive_mean', // Výchozí dle požadavku
};

/**
 * Načte nastavení skeneru z databáze. Pokud nejsou nalezena nebo jsou neplatná,
 * vrátí výchozí hodnoty.
 */
export const getScannerSettings = async (): Promise<ScannerSettings> => {
    try {
        const stored = await apiService.getPreference<ScannerSettings>(SCANNER_SETTINGS_KEY, DEFAULT_SCANNER_SETTINGS);
        // Ověříme, že klíčové vlastnosti existují, jinak použijeme výchozí.
        if (stored && typeof stored.jpegQuality === 'number' && typeof stored.defaultPaperSnapEffect === 'string') {
            return { ...DEFAULT_SCANNER_SETTINGS, ...stored };
        }
    } catch (e) {
        logger.error("Nepodařilo se načíst nastavení skeneru z DB", e);
    }
    return DEFAULT_SCANNER_SETTINGS;
};

/**
 * Uloží nastavení skeneru do databáze.
 */
export const saveScannerSettings = async (settings: ScannerSettings): Promise<void> => {
    try {
        await apiService.setPreference(SCANNER_SETTINGS_KEY, settings);
    } catch (e) {
        logger.error("Nepodařilo se uložit nastavení skeneru do DB", e);
        throw e;
    }
};